import { fetchApi } from '@/config/axiosSetting';
import { GetBodyInsuranceType } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyInsurance/getBodyInsurance.type';
import { BodyInsuranceResponseType } from '@/modules/adjusterReportModules/Insurer-information/types/BodyInsurance.type';

export const getBodyInsuranceFunction = (
  params: GetBodyInsuranceType,
): Promise<BodyInsuranceResponseType> => {
  return fetchApi.get(`/body/reports/${params.id}/insurance_information/`);
};
